import React from 'react';
import { AiOutlineEye, AiOutlinePlus } from 'react-icons/ai';
import { MdEdit } from 'react-icons/md';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Search, Table } from 'src/components';
import { fetchCustomer } from 'src/redux/action/customer.action';
import { RootState } from 'src/redux/reducers';
import AddEditCustomer from './crud/AddEditCustomer';

import Button from 'src/components/button';

interface IProps {}

const Customer: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [editCustomer, setEditCustomer] = React.useState(false);
  const [editCustomerId, setEditCustomerId] = React.useState('');
  const [editCustomerData, setEditCustomerData] = React.useState([]);
  const [query, setQuery] = React.useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isHidden, setIsHidden] = React.useState(true);
  const onClick = () => {
    setIsHidden(true);
  };

  const { customerData, loading } = useSelector(
    ({ customerData }: RootState) => customerData,
    shallowEqual
  );

  React.useEffect(() => {
    if (customerData.length > 0) return;
    dispatch(fetchCustomer() as any);
  }, [dispatch]);

  const handleAddCustomer = () => {
    setEditCustomer(false);
    setEditCustomerId('');
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleEditCustomer = (data: any) => {
    setEditCustomerData(data);
    setEditCustomer(true);
    setEditCustomerId(data.id);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setIsHidden(false);
  };
  // const searchDesignationData = customerData?.filter((item) => {
  //   if (query === '') {
  //     return item;
  //   } else if (item) {
  //     return item?.name?.toLowerCase().includes(query.toLowerCase());
  //   }
  // });

  const searchDesignationData =
    customerData && Object.keys(customerData).length > 0
      ? customerData.filter((item) => {
          if (query === '') {
            return item;
          } else if (item) {
            return (
              item?.name?.toLowerCase().includes(query.toLowerCase()) ||
              item?.phone.includes(query)
            );
          }
        })
      : [];

  const tableColumn = [
    {
      Header: 'Customer Name',
      accessor: 'employeeName',
      Cell: (row: any) => (
        <div className="flex items-center space-x-3 w-[100px] xl:w-[200px] overflow-hidden">
          <div className="capitalize w-8 h-8 rounded-full bg-black text-white text-xl flex items-center justify-center">
            {row?.cell?.row?.original?.name?.[0]}
          </div>
          <p className="text-text-black whitespace-nowrap overflow-hidden text-ellipsis">
            {row?.cell?.row?.original?.name}
          </p>
        </div>
      ),
    },
    { Header: 'Contact', accessor: 'phone' },
    { Header: 'Email', accessor: 'email' },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: (row: any) => (
        <div className="flex items-center space-x-3">
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEditCustomer(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() =>
              navigate(`/customer-detail/${row?.cell?.row?.original?.id}`)
            }
          >
            <AiOutlineEye color="#4062FF" />
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="grid grid-cols-12 gap-5">
        <div className="col-span-12">
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search customer"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Customer'}
              variant="primary"
              onClick={() => {
                handleAddCustomer();
                setEditCustomer(false);
                setEditCustomerId('');
              }}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <div className="grid">
            <Table
              loading={loading}
              pagination={true}
              tableColumn={tableColumn}
              tableData={searchDesignationData}
            />
          </div>
        </div>
        <AddEditCustomer
          onClick={onClick}
          isHidden={isHidden}
          editCustomerData={editCustomerData}
          showModal={showModal}
          fetchData={() => {}}
          handleModal={handleModal}
          editCustomer={editCustomer}
          setEditCustomer={setEditCustomer}
          editCustomerId={editCustomerId}
          setEditCustomerId={setEditCustomerId}
        />
      </div>
      {/* add modal */}
    </>
  );
};

export default React.memo(Customer);
